import gsap from 'gsap';

export default function initSolution() {
    const sticky = document.querySelector('.solution-sticky');
    if (!sticky) return;

    const stats = sticky.querySelector('.solution-sticky__inner__stats');
    if (!stats) return;

    let isCollapsed = false;
    let isHovered = false;

    // Helper to check if we are on mobile
    const isMobile = () => window.innerWidth <= 991;

    const collapse = (immediate = false) => {
        if (isCollapsed && !immediate) return;
        isCollapsed = true;

        gsap.to(stats, {
            height: 0,
            opacity: 0,
            duration: immediate ? 0 : 0.4,
            ease: 'power2.inOut',
            overwrite: true
        });
    };

    const expand = (immediate = false) => {
        if (!isCollapsed && !immediate) return;
        isCollapsed = false;

        gsap.to(stats, {
            height: 'auto',
            opacity: 1,
            duration: immediate ? 0 : 0.4,
            ease: 'power2.inOut',
            overwrite: true
        });
    };

    const handleScroll = () => {
        if (window.scrollY > 50) {
            sticky.classList.add('is-scrolled');
            if (!isMobile()) {
                if (!isHovered) {
                    collapse();
                }
            }
        } else {
            sticky.classList.remove('is-scrolled');
            if (!isMobile()) {
                expand();
            }
        }
    };

    // Click interaction for all
    sticky.addEventListener('click', (e) => {
        // Clicking toggles visibility
        if (isCollapsed) {
            isHovered = true;
            expand();
        } else {
            isHovered = false;
            collapse();
        }
    });

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', () => {
        // Reset state on resize if needed, or ensuring layout is correct
        // For now just letting CSS handle most, but scroll handler might need re-check
        handleScroll();
    });

    // Initial check
    if (isMobile()) {
        collapse(true);
    }
    handleScroll();
}
